import React, { ReactNode } from 'react'

import { Box, Divider } from '@mui/material'

import * as S from './styles'

export interface RadioBoxContainerProps {
  headerContent?: ReactNode
  children: ReactNode
  showDivider?: boolean
  headerPadding?: string | number
  bodyPadding?: string | number
  margin?: string | number
  sx?: React.CSSProperties
}

const RadioBoxContainer: React.FC<RadioBoxContainerProps> = ({
  headerContent,
  children,
  showDivider = true,
  headerPadding = '8px 16px',
  bodyPadding = 2,
  margin = 2,
  sx
}) => {
  return (
    <S.Wrapper margin={margin} sx={sx}>
      <Box>
        {headerContent && <Box p={headerPadding}>{headerContent}</Box>}
        {headerContent && showDivider && <Divider />}
        <Box p={bodyPadding}>{children}</Box>
      </Box>
    </S.Wrapper>
  )
}

export default RadioBoxContainer
